import React from 'react';
import './AboutUs.css';
import aboutusImage from '../images/aboutus.png';
import aboutusImage1 from '../images/aboutus-1.jpg';
import Header from "../Header/Header"
import HeroSection from '../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import {Tabs, Tab } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Footer from '../Footer/Footer';
import ReactGA from 'react-ga';

class AboutUs extends React.Component{
    constructor() {
        super();
        this.state = {
            loading: false,
        }
        this.load = this.load.bind(this);
    }
    load() {
         this.setState({loading: true});
        setTimeout(() => { 
            this.setState(() => ({loading: false}),
            )
        }, 500);
    }
     componentDidMount() {
         window.scrollTo(0, 0);
          ReactGA.pageview('/aboutus');
     }
    render() {
         let loader = '';
       if (this.state.loading === true) {
            loader = <div className="loader-container">
                <i className="fa fa-spinner fa-spin"></i>
            </div>
       }
       return (
        <div className="aboutus">
            <Header />
            <HeroSection background={aboutusImage} pageTitle="" />
            <section className="page-content">
            
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/aboutus" className="current">About us</Link></li>
                    </ul>
                    <Row className="about-section row-eq-height">
                        <Col col="col-md-5 12" offset="md-1" className="about-image-container">
                            <img src={aboutusImage1}/>
                        </Col>
                        <Col col="col-md-6 12" className="tabs-container">
                        {loader}
                        <h2 className="second-title"><i className="fa fa-circle"></i> <span> About Us </span><i className="fa fa-circle"></i></h2>
                            <Tabs defaultActiveKey="experience" id="uncontrolled-tab-example" style={{marginBottom: '60px'}}  onClick={this.load}>
                                <Tab eventKey="experience" title="Experience">
                                    <p>
                                    Established in France in 2009, we are a Design-Build-Operate technology company delivering complete cloud-managed solutions. Our clients are mobile network operators, retailers, banks and financial services companies and gaming operators across the world with a focus on the growing economies, notably in Africa.
                                    <br/><br/>
                                    We leverage mobile networks and the latest technology to help our clients reach, entertain and communicate with their customers regardless of the device they use. Our clients can track, evaluate and monetize our products and services allowing them to achieve their business objectives.
                                    <br/><br/>
                                    Moobifun is backed by one of the largest independent consulting, financial services and insurance groups, established
                                    for over 75 years employing specialists worldwide from its offices in 20 + countries in Europe, the Americas, Africa, the Middle East and Asia.
                                     </p>
                                </Tab>
                                <Tab eventKey="skills" title="Skills">
                                    <p>
                                        Moobifun offers easy integration
                                        for clients, removing the need
                                        for them to learn complex telecommunications interfaces. We allow
                                        for the fast provision of services, reducing the cost of entry and delivery time into the market.
                                        Our breadth of expertise and depth of resources mean we can manage complex multi-stakeholder, multi-country projects with rapid deployment. Our in-house research and development team designs and develops innovative games, services and software tailored to our clients’ needs on our secure cloud environment.
<br/><br/>
                                        We have built excellent relationships with the major mobile network operators in which our clients conduct their business. We have a proven track record of delivering projects successfully across the world’ s growth markets.
                                        <br/><br/>
                                         We run mobile services in more than 25 countries:
                                         <br/><br/>
                                            12 African countries
<br/>
                                            25 mobile operator partnerships
<br/>
                                             More than 110 million covered subscribers
<br/>
                                            More than 15 million active subscribers
<br/>
                                            More than 25 million financial transactions per day
                                    </p>
                                </Tab>
                                <Tab eventKey="mission" title="Mission">
                                    <p>
                                        Moobifun’ s mission is to work in partnership with clients to provide the vital link between businesses and customers via their preferred mobile channels.
                                        </p>			
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
        </div>
       );
    }
}
export default AboutUs;
